import React from 'react';

const GainGuruIcon = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62.2 62.44"
      className="svg-icon"
   >
      <g id="Layer_2" data-name="Layer 2">
         <g id="Layer_1-2" data-name="Layer 1">
            <path
               className="svg-icon-background"
               d="M51.7,62.44H10.5A10.51,10.51,0,0,1,0,51.94V10.5A10.51,10.51,0,0,1,10.5,0H51.7A10.51,10.51,0,0,1,62.2,10.5V51.94A10.51,10.51,0,0,1,51.7,62.44Z"
            />
            <path
               className="svg-icon-decoration"
               d="M9.82,1.5H52.37A8.32,8.32,0,0,1,60.7,9.82v9.49a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V9.82A8.32,8.32,0,0,1,9.82,1.5Z"
            />
            <path
               className="svg-icon-highlight"
               d="M13.92,13.7h0a3,3,0,1,1,3-3,3,3,0,0,1-3,3"
            />
            <path
               className="cls-4"
               d="M25.67,13.7h0a3,3,0,1,1,3-3,3,3,0,0,1-3,3"
            />
            <path
               className="cls-4"
               d="M37.42,13.7h0a3,3,0,1,1,3-3,3,3,0,0,1-3,3"
            />
            <path
               className="cls-4"
               d="M49.17,13.7h0a3,3,0,1,1,3-3,3,3,0,0,1-3,3"
            />
            <rect
               className="svg-icon-background"
               x="10.25"
               y="28.73"
               width="7.33"
               height="2.53"
               rx="1.26"
            />
            <rect
               className="svg-icon-background"
               x="33.75"
               y="34.21"
               width="7.33"
               height="2.53"
               rx="1.26"
            />
            <rect
               className="svg-icon-background"
               x="22"
               y="48.8"
               width="7.33"
               height="2.53"
               rx="1.26"
            />
            <rect
               className="svg-icon-background"
               x="44.62"
               y="48.8"
               width="7.33"
               height="2.53"
               rx="1.26"
            />
            <path
               className="svg-icon-highlight"
               d="M16.32,27.23h-4.8a2.77,2.77,0,1,0,0,5.53h.9V60.94a1.5,1.5,0,0,0,3,0V32.76h.9a2.77,2.77,0,0,0,0-5.53Z"
            />
            <path
               className="svg-icon-highlight"
               d="M39.82,32.71h-.9v-4a1.5,1.5,0,0,0-3,0v4H35a2.77,2.77,0,1,0,0,5.53h.9v22.7a1.5,1.5,0,0,0,3,0V38.24h.9a2.77,2.77,0,0,0,0-5.53Z"
            />
            <path
               className="svg-icon-highlight"
               d="M28.07,47.3h-.9V28.73a1.5,1.5,0,0,0-3,0V47.3h-.9a2.77,2.77,0,1,0,0,5.53h.9v8.11a1.5,1.5,0,0,0,3,0V52.83h.9a2.77,2.77,0,0,0,0-5.53Z"
            />
            <path
               className="svg-icon-highlight"
               d="M50.68,47.3h-.9V28.73a1.5,1.5,0,0,0-3,0V47.3h-.9a2.77,2.77,0,0,0,0,5.53h.9v8.11a1.5,1.5,0,0,0,3,0V52.83h.9a2.77,2.77,0,0,0,0-5.53Z"
            />
            <path
               className="cls-4"
               d="M51.7,62.44H10.5A10.51,10.51,0,0,1,0,51.94V10.5A10.51,10.51,0,0,1,10.5,0H51.7A10.51,10.51,0,0,1,62.2,10.5V51.94A10.51,10.51,0,0,1,51.7,62.44ZM10.5,3A7.5,7.5,0,0,0,3,10.5V51.94a7.51,7.51,0,0,0,7.5,7.5H51.7a7.52,7.52,0,0,0,7.5-7.5V10.5A7.51,7.51,0,0,0,51.7,3Z"
            />
         </g>
      </g>
   </svg>
);

export { GainGuruIcon };
